import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { ApiService } from "src/app/core/services/api.service";
import { ToastService } from "src/app/core/services/toast.service";

@Component({
	selector: "app-send-notifications",
	templateUrl: "./send-notifications.component.html",
	styleUrls: ["./send-notifications.component.scss"],
})
export class SendNotificationsComponent implements OnInit {
	public active: any;
	public loading: boolean = false;
	public customers1: any[] = [];
	public typeUsers = [
		{
			label: "Con suscripción",
			key: "sub",
			value: 1,
		},
		{
			label: "Sin suscripción",
			key: "noSub",
			value: 2,
		},
	];
	form: FormGroup = this.fb.group({
		title: ["", Validators.required],
		content: ["", Validators.required],
		type: [""],
	});

	constructor(
		private toast: ToastService,
		private confirmationService: ConfirmationService,
		private apiService: ApiService,
		private fb: FormBuilder
	) {}

	ngOnInit(): void {
		this.handleView(0);
	}

	public handleView(event) {
		this.apiService.getEntity("getUsersByGroup", event).subscribe({
			next: (result) => {
				if (result.status === 1) {
					this.customers1 = result.users;
				}
			},
			error: () => {},
		});
	}

	public sendNotification() {
		this.form.markAllAsTouched();
		if (this.form.invalid) {
			return this.toast.show(
				"Aviso",
				"Revise los campos del formulario",
				"warn"
			);
		}

		if (this.customers1.length === 0) {
			return this.toast.show(
				"Aviso",
				"No hay usuarios para enviar la notificación",
				"warn"
			);
		}

		this.loading = true;

		this.apiService
			.addEntity("sendMassiveNotification", {
				users: this.customers1,
				notification: this.form.value,
			})
			.subscribe({
				next: (result) => {
					this.toast.show("Notificación enviada correctamente");
					this.loading = false;
					this.form.reset();
				},
				error: (err) => {
					console.log(err);
					this.loading = false;
					this.toast.show(
						"Error",
						"Ocurrió un error al enviar la notificación, inténtelo de nuevo",
						"error"
					);
				},
				complete: () => {
					this.loading = false;
				},
			});
	}
}
